export const gitCommit = '3e22f569'
